import { Component, OnInit } from '@angular/core';
import { GenericService } from '../../services/generic.service';
import { AggregationService } from '../../services/aggregation.service'
import { AnalyticService } from '../../services/analytic.service';
import { LinkService } from '../../services/link.service';
import { RetirementService } from '../../services/retirement.service'
import { SessionStorageService } from "../../services/web-storage/session-storage.service";
import { PznService } from "../../services/pzn.service";
import * as platFormLib from '../../implconfig/aggrConfig';
declare var environment: any;

@Component({
  selector: "retirement-component",
  templateUrl: "./retirement.component.html",
  styleUrls: ["./retirement.component.scss"]
})
export class RetirementComponent implements OnInit {
  retirementData: any;
  genericAggregator: any;
  math = Math;
  retirementDomain = environment.RETIREMENT_DOMAIN;
  singleRet: boolean = false;
  displayRic: boolean = false;
  redesign: boolean = false;
  ndgCnt: any;
  permissioned: boolean = false;
  constructor(
    public _genericService: GenericService,
    private _aggregationService: AggregationService,
    private _analyticService: AnalyticService,
    private _linkService: LinkService,
    private _sessionStorageService: SessionStorageService,
    private _retirementService: RetirementService,
    private _pznService: PznService
  ) { }
  ngOnInit() {
    this._genericService.nudgeObs$.subscribe((res:any)=>{
      this.ndgCnt = res;
    });
    this._genericService.toggleObs$.subscribe((res: any) => {
      this.redesign = res;
    });

    this._retirementService.getRetirementData$().subscribe(
      serviceData => {
        if (parseInt(serviceData["responseCode"]) === 403) {
          this._genericService.callUiLogger(serviceData["responseStatus"]);
        }
        this.genericAggregator = new platFormLib[this._genericService.appTitle](
          this._genericService.appTitle
        );
        this.genericAggregator.aggregationImpl(
          serviceData,
          "Y",
          this._genericService,
          this._aggregationService,
          "false",
          this._analyticService,
          this._linkService
        );
        this.retirementData = serviceData;
        if (serviceData.contractSummaryResponse && serviceData.contractSummaryResponse.contractSummary && serviceData.contractSummaryResponse.contractSummary.length > 0) {
          this.singleRet = serviceData.contractSummaryResponse.contractSummary.length > 1 ? false : true;
        }
        this.displayRic = true;
        if (!this.retirementData["businessUnit"])
          this.retirementData["businessUnit"] = "Retirement";
        setTimeout(() => {
          let event;
          if (typeof Event === "function") {
            event = new Event("retirementContainerRendered");
          } else {
            event = document.createEvent("Event");
            event.initEvent("retirementContainerRendered", true, true);
          }
          document.dispatchEvent(event);
        }, 0);
      },
      error => {
        this.retirementData = { businessUnit: "Retirement" };
        let errmsg = error.error;
        if (errmsg.responseCode)
          this.retirementData.responseCode = errmsg.responseCode;
        console.log("contractsummary error: ", this.retirementData);
        this._aggregationService.emitAggDone();
      }
    );
  }

  getContributionCTAUrl(val) {
    let ctaUrl = "";
    const retActions = val.accountActions;
    if (retActions) {
      for (let i = 0; i < retActions.length; i++) {
        if (/Contributions/gi.test(retActions[i].actionTitle)) {
          ctaUrl = retActions[i].actionTarget;
          break;
        }
      }
    }
    return ctaUrl;
  }
}
